// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cvss-calc {\n  width: 100%;\n}\n.cvss-calc-2-btn > .btn {\n  width: 50%;\n  max-width: 50%;\n}\n.cvss-calc-3-btn > .btn {\n  width: 33%;\n  max-width: 33%;\n}\n.cvss-calc-4-btn > .btn {\n  width: 25%;\n  max-width: 25%;\n}\n.vue-easy-pie-chart .inner-text {\n  color: var(--primary-lighter);\n  font-size: 2rem;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
